var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0"},[_c('span',{staticClass:"legend",attrs:{"role":"presentation"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.legend)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }